/* src/app/shared/dialogs/bigger-image-dialog/bigger-image-dialog.component.scss */
::ng-deep .mat-mdc-dialog-surface {
  width: fit-content !important;
  height: fit-content !important;
  border-radius: 16px;
}
.image-box {
  border-radius: 16px;
  background: #ffffff;
  display: flex;
  position: relative;
  width: fit-content;
  height: fit-content;
}
.image-box__image {
  display: block;
  max-width: min(600px, 80vw);
  max-height: min(600px, 80vh);
  width: auto;
  height: auto;
  border-radius: 16px;
}
/*# sourceMappingURL=bigger-image-dialog.component.css.map */
